import type { ReactElement, VFC } from "react";
import { useEffect, useState } from "react";
import ReactDOM from "react-dom";

interface Props {
  portalClassName?: string;
  children: ReactElement;
}

export const Portal: VFC<Props> = ({ children, portalClassName }) => {
  const [node, setNode] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const node = document.createElement("div");
    node.className = `kibelaPortal ${portalClassName}`;
    setNode(node);
    document.body.appendChild(node);

    return () => {
      document.body.removeChild(node);
    };
  }, [setNode, portalClassName]);

  if (!node) {
    return <></>;
  }

  return ReactDOM.createPortal(children, node);
};
